import React from "react";
import "./USDT_Content.css";
import { Link } from "react-router-dom";

function USDT_Content() {
  return (
    <>
      <section className="USDT_Content UPI_QR_Content">
        <div className="support_box_holder add_upi_box_holder">
          <Link to={"/self-service-center"}>
            <div className="img_holder">
              <img
                src="/assets/images/icons/call-center-agent.png"
                className="support_img"
                alt="support"
              />
            </div>
          </Link>
          <p>Contact Customer Service Add USDT Address</p>
        </div>
      </section>
    </>
  );
}

export default USDT_Content;
